import useApplicationSettings, { ApplicationTheme } from './applicationSettingsContext';

/**
 * Helper return layouts that were define in context and sets to all component type T.
 */
const useUiTheme: <T extends ReactComponent<any>>() => ApplicationTheme<T> = () => {
  const { theme } = useApplicationSettings();

  return theme || ({} as ApplicationTheme<any>);
};

export default useUiTheme;
